import React, { useContext } from 'react';
import cn from 'classnames';
import { CrossIcon } from '@gwc/icons';
import { Button } from '../../button';
import { ModalContext } from '../contexts';
import styles from './styles.module.css';
export const Close = ({ className, ...rest }) => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Modal component has to be placed inside Modal.Overlay');
    }
    const { modalProps: { onClose } } = context;
    return (React.createElement(Button.Simple, { className: cn(styles.close, className), shape: "circle", size: "s", variant: "ghost", "aria-label": "close", pl: "s", pr: "s", onPress: onClose, ...rest },
        React.createElement(CrossIcon, null)));
};
